// ProfileSidebar Component
// Sticky sidebar for profile page (LinkedIn-style)

import React from 'react';
import { FaEdit, FaChartLine, FaShare, FaTrophy, FaUsers, FaCalendarCheck } from 'react-icons/fa';
import ProfileCompleteness from './ProfileCompleteness';
import styles from './ProfileSidebar.module.css';

const ProfileSidebar = ({ 
  isOwner, 
  profileCompleteness,
  profileId,
  stats = {},
  onEdit,
  onViewAnalytics,
  onShare
}) => {
  const { awards, clubs, events } = stats;

  return (
    <div className={styles.sidebar}>
      {/* Quick Actions */}
      {isOwner && (
        <div className={styles.card}>
          <h3 className={styles.cardTitle}>Quick Actions</h3>
          <div className={styles.actions}>
            <button className={styles.actionButton} onClick={onEdit}>
              <FaEdit />
              <span>Edit Profile</span>
            </button>
            <button className={styles.actionButton} onClick={onViewAnalytics}>
              <FaChartLine />
              <span>View Analytics</span>
            </button>
            <button className={styles.actionButton} onClick={onShare}>
              <FaShare />
              <span>Share Profile</span>
            </button>
          </div>
        </div>
      )}

      {/* Profile Stats */}
      {isOwner && (
        <div className={styles.card}>
          <h3 className={styles.cardTitle}>Profile Status</h3>
          <ProfileCompleteness 
            score={profileCompleteness} 
            profileId={profileId}
            onEdit={onEdit}
            compact
          />
        </div>
      )}

      {/* At a Glance */}
      {(awards > 0 || clubs > 0 || events > 0) && (
        <div className={styles.card}>
          <h3 className={styles.cardTitle}>At a Glance</h3>
          <div className={styles.stats}>
            {awards > 0 && (
              <div className={styles.statItem}>
                <div className={styles.statIcon}>
                  <FaTrophy />
                </div>
                <div className={styles.statContent}>
                  <div className={styles.statValue}>{awards}</div>
                  <div className={styles.statLabel}>Awards</div>
                </div>
              </div>
            )}
            {clubs > 0 && (
              <div className={styles.statItem}>
                <div className={styles.statIcon}>
                  <FaUsers />
                </div>
                <div className={styles.statContent}>
                  <div className={styles.statValue}>{clubs}</div>
                  <div className={styles.statLabel}>Clubs</div>
                </div>
              </div>
            )}
            {events > 0 && (
              <div className={styles.statItem}>
                <div className={styles.statIcon}>
                  <FaCalendarCheck />
                </div>
                <div className={styles.statContent}>
                  <div className={styles.statValue}>{events}</div>
                  <div className={styles.statLabel}>Events</div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Contact Info - Privacy Controlled */}
      {!isOwner && (
        <div className={styles.card}>
          <h3 className={styles.cardTitle}>Connect</h3>
          <p className={styles.connectText}>
            Sign in to connect with this player and view contact information.
          </p>
        </div>
      )}
    </div>
  );
};

export default ProfileSidebar;

